// slice reducer
import { createSlice } from '@reduxjs/toolkit'

export const currentUserSlice = createSlice( {
  name:         'currentUser',
  initialState: {
    user:                 null,
    location:             null,
    accountTypes:         [],
    locations:            [],
    locationsListRefetch: false
  },
  reducers:     {
    setCurrentUser:          ( state, action ) => {
      state.user = action.payload
    },
    setCurrentUserLocation:  ( state, action ) => {
      state.location = action.payload
    },
    setAccountTypes:         ( state, action ) => {
      state.accountTypes = action.payload
    },
    setLocations:            ( state, action ) => {
      state.locations = action.payload
    },
    setLocationsListRefetch: ( state, action ) => {
      state.locationsListRefetch = action.payload
    }
  }
} )

export const {
               setCurrentUser,
               setCurrentUserLocation,
               setAccountTypes,
               setLocations,
               setLocationsListRefetch
             } = currentUserSlice.actions

export default currentUserSlice.reducer
